export var submitStateActionTypes;
(function (submitStateActionTypes) {
    submitStateActionTypes["INITIAL_SUBMIT_STATE"] = "INITIAL_SUBMIT_STATE";
    submitStateActionTypes["SUBMITED_STATE_ACTION"] = "SUBMITED_STATE_ACTION";
    submitStateActionTypes["SUBMIT_CANCEL_STATE_ACTION"] = "SUBMIT_CANCEL_STATE_ACTION";
    submitStateActionTypes["PRODUCT_TYPE_CHANGED_STATE_ACTION"] = "PRODUCT_TYPE_CHANGED_STATE_ACTION";
})(submitStateActionTypes || (submitStateActionTypes = {}));
